import React, { createContext, useMemo } from "react";
import type { PageThemeDefinition } from "./types";
import { resolveTheme } from "./registry";
import { tokensToCssVars } from "./themeToCssVars";

export const PageThemeContext = createContext<PageThemeDefinition>(
  resolveTheme()
);

interface PageThemeProviderProps {
  themeId?: string;
  theme?: PageThemeDefinition;
  children: React.ReactNode;
}

export const PageThemeProvider: React.FC<PageThemeProviderProps> = ({
  themeId,
  theme,
  children,
}) => {
  const value = useMemo(
    () => theme ?? resolveTheme(themeId),
    [theme, themeId]
  );

  const cssVars = useMemo(
    () => tokensToCssVars(value.tokens),
    [value.tokens]
  );

  return (
    <PageThemeContext.Provider value={value}>
      <div data-uchat-theme={value.id} style={cssVars}>
        {children}
      </div>
    </PageThemeContext.Provider>
  );
};
